module.exports = __webpack_public_path__ + "img/dropdown.6b2a7a80.svg";